import styled from 'styled-components';

export const Root = styled.span`
	display: flex;
	flex-direction: row;
	align-items: center;
	max-width: 100%;
	width: fit-content;
	text-overflow: ellipsis;
	overflow: hidden;
	${({ $wrap }) => $wrap && 'flex-wrap: wrap;'}

	& > * {
		flex-shrink: 0;
	}
`;

export const NoWrap = styled.span`
	display: flex;
	flex-wrap: nowrap;
	align-items: baseline;
	${({ $withDistance }) => $withDistance && 'margin-right: 10px;'}
`;

export const MetroText = styled.span`
	display: block;
	flex-shrink: 1;
	overflow: hidden;
	margin-left: 4px;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
